export const MODIFIED_NEW_DISPLAY_NAME_IN_SETTINGS = 'MODIFIED_NEW_DISPLAY_NAME_IN_SETTINGS'
export const SELECTED_NEW_PROFILE_PICTURE_IN_SETTINGS = 'SELECTED_NEW_PROFILE_PICTURE_IN_SETTINGS'
export const RESET_SETTINGS_PAGE = 'RESET_SETTINGS_PAGE'
export const TOGGLED_FULLSCREEN_MODE = 'TOGGLED_FULLSCREEN_MODE'
